import { Link } from "react-router-dom";
import { Linkedin, Github, Youtube, Facebook, Instagram, Mail } from "lucide-react";
import { Logo } from "./Logo";

const COLS = [
  { title: "Company", links: [["About", "/about"], ["Services", "/services"], ["Contact", "/contact"]] },
  { title: "Solutions", links: [["AI & Automation", "/ai-automation"], ["Software Engineering", "/software-engineering"], ["SefKam Home", "/sefkam-home"], ["Digital Transformation", "/services"]] },
  { title: "Resources", links: [["Insights", "/blog"], ["FAQs", "/contact"]] },
  { title: "Legal", links: [["Privacy Policy", "/privacy"], ["Terms of Service", "/terms"]] },
];

export default function Footer() {
  return (
    <footer className="relative overflow-hidden bg-[#0B1220] text-white" data-testid="site-footer">
      <div className="container-x py-20">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_2fr]">
          <div>
            <Logo dark />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">
              Building intelligent digital solutions for a smarter future.
            </p>
            <a href="mailto:contact@sefkam.com" className="mt-5 inline-flex items-center gap-2 text-sm text-slate-300 hover:text-white transition-colors" data-testid="footer-email">
              <Mail size={16} /> contact@sefkam.com
            </a>
            <div className="mt-6 flex items-center gap-3">
              {[
                [Linkedin, "LinkedIn", "https://www.linkedin.com"],
                [Github, "GitHub", "https://github.com"],
                [Youtube, "YouTube", "https://www.youtube.com"],
                [Facebook, "Facebook", "https://www.facebook.com"],
                [Instagram, "Instagram", "https://www.instagram.com"],
              ].map(([Icon, name, url]) => (
                <a
                  key={name} href={url} target="_blank" rel="noopener noreferrer" aria-label={name}
                  data-testid={`footer-social-${name.toLowerCase()}`}
                  className="grid h-10 w-10 place-items-center rounded-full border border-white/10 text-slate-300 transition-colors hover:border-white/40 hover:text-white"
                >
                  <Icon size={18} />
                </a>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-4">
            {COLS.map((col) => (
              <div key={col.title}>
                <h4 className="overline text-slate-500">{col.title}</h4>
                <ul className="mt-4 space-y-3">
                  {col.links.map(([label, to]) => (
                    <li key={label}>
                      <Link to={to} className="text-sm text-slate-300 transition-colors hover:text-white" data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                        {label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="relative border-t border-white/5">
        <div className="pointer-events-none select-none text-center leading-none">
          <span className="block font-display font-semibold tracking-tighter text-transparent [font-size:22vw] [-webkit-text-stroke:1px_rgba(148,163,184,0.10)]">
            SefKam
          </span>
        </div>
      </div>

      <div className="container-x flex flex-col items-center justify-between gap-3 border-t border-white/5 py-6 text-xs text-slate-500 sm:flex-row">
        <span>© 2026 SefKam Digital Solutions. All rights reserved.</span>
        <span>Software • AI • Automation • Smart Home</span>
      </div>
    </footer>
  );
}
